var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', _vm._g(_vm._b({
    staticClass: "local-svg-icon",
    class: {
      'local-svg-icon-original-color': !_vm.inheritColor
    },
    attrs: {
      "aria-label": _vm.alt,
      "aria-hidden": _vm.alt ? 'false' : 'true',
      "role": "img"
    }
  }, 'span', _vm.$attrs, false), _vm.$listeners), [_vm.iconSource.type === 'image' ? _c('img', {
    staticClass: "local-svg-icon-image",
    attrs: {
      "src": _vm.iconSource.url,
      "alt": "",
      "draggable": "false"
    }
  }) : _vm.spriteReady ? _c('svg', {
    staticClass: "local-svg-icon-svg",
    attrs: {
      "focusable": "false",
      "aria-hidden": _vm.alt ? 'false' : 'true'
    }
  }, [_c('use', {
    attrs: {
      "href": _vm.iconSource.href,
      "xlink:href": _vm.iconSource.href
    }
  })]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };